import { TargetItemFactoryOptions } from "../../modules/common/create-related-items/create-related-items.interfaces"
import { OpLocation, OpTask, OpIssue } from "../../models/core"
import { IOpObject, IOpData } from "../../models/util/interfaces"
import { Enums } from "../../models/common";
import { LogHelper } from "../../helpers";
import { LocationService } from "./location.service";

// #region Consts

export const LOCATION_RELATED_OBJECT_SERVICE_NAME: string = 'LocationRelatedObjectService'
export const LOCATION_RELATED_OBJECT_SERVICE_PROVIDER_NAME: string = 'LocationRelatedObjectServiceProvider'

// #endregion

export class LocationRelatedObjectService {
    // #region Consts

    // #endregion

    // #region Ctor

    constructor(
    ) {
    }

    // #endregion

    // #region Public Methods

    public createTaskFromLocation(factoryOptions: TargetItemFactoryOptions<OpLocation>): OpTask {
        return this.createRelatedObject<OpTask>(
            new OpTask(null),
            factoryOptions,
            (obj: OpTask, idLocation: number, idDistributor: number, creationDate: Date) => {
                obj.idLocation = idLocation
                obj.idDistributor = idDistributor
                obj.creationDate = creationDate
            }
        )
    }

    public createIssueFromLocation(factoryOptions: TargetItemFactoryOptions<OpLocation>): OpIssue {
        return this.createRelatedObject<OpIssue>(
            new OpIssue(null),
            factoryOptions,
            (obj: OpIssue, idLocation: number, idDistributor: number, creationDate: Date) => {
                obj.idLocation = idLocation
                obj.idDistributor = idDistributor
                obj.creationDate = creationDate
            }
        )
    }

    public createRelatedObject<T extends IOpObject>(
        obj: T,
        factoryOptions: TargetItemFactoryOptions<OpLocation>,
        setRequiredValues: (obj: T, idLocation: number, idDistributor: number, creationDate: Date) => void
    ): T {
        if (factoryOptions == null) {
            LogHelper.error(LocationService.LOG_PREFIX, 'Missing factory options')
            return null
        }

        if (factoryOptions.sourceObject == null) {
            LogHelper.error(LocationService.LOG_PREFIX, 'SourceObject is null')
            return null
        }

        const idLocation: number = factoryOptions.sourceObject.idLocation
        let idDistributor: number = null
        let creationDate: Date = null

        if (factoryOptions.sourceObject.dataList != null) {
            idDistributor = factoryOptions.sourceObject.dataList.getValue(Enums.DataType.HELPER_ID_DISTRIBUTOR, 0, null)
        }

        if (factoryOptions.dataList != null) {
            factoryOptions.dataList.forEach((data: IOpData) => {
                obj.dataList.setValue(data.value, data.idDataType, data.indexNBR)
            })
        }

        const creationDateData: IOpData = obj.dataList.getData(Enums.DataType.HELPER_CREATION_DATE, 0)
        if (creationDateData != null) {
            creationDate = creationDateData.value
        }

        creationDate = creationDate || new Date()

        setRequiredValues(obj, idLocation, idDistributor, creationDate)

        obj.dataList.setValue(idLocation, Enums.DataType.HELPER_ID_LOCATION, 0)
        obj.dataList.setValue(idDistributor, Enums.DataType.HELPER_ID_DISTRIBUTOR, 0)
        obj.dataList.setValue(creationDate, Enums.DataType.HELPER_CREATION_DATE, 0)

        obj.opState = Enums.OpChangeState.New

        return obj
    }

    // #endregion

    // #region Private Methods

    // #endregion
}

export class LocationRelatedObjectServiceProvider
    implements ng.IServiceProvider
{
    // #region IServiceProvider Implementation 

    public $get = [
        function () {
            return new LocationRelatedObjectService()
        }
    ]

    // #endregion
} 
